import { array, number, object, SchemaOf, string } from "yup";
import { requiredFieldValidationMessage } from "../../Forms/ValidationMessages";
import { yupGsdbValidation } from "../../Forms/yupGsdbValidation";
import { nameOf } from "../../Utils/nameOf";
import Odc from "../Odc";
import { yupTimesValidation } from "../../Forms/yupTimesValidation";
import { CountryHandlingTime } from "../CountryHandlingTime";
import { SupplierHandlingTime } from "../SupplierHandlingTime";
import { SprHandlingTime } from "../SprHandlingTime";
import { OdcType } from "../OdcType";

const countryHandlingTimesValidation = () =>
  array().when(nameOf<Odc>("Type"), {
    is: OdcType.ODC,
    then: array().of(
      object().shape({
        CountryId: number().notOneOf([null, 0], "Please choose a Country"),
        HandlingTime: yupTimesValidation<CountryHandlingTime>("HandlingTime"),
      })
    ),
    otherwise: undefined,
  });

const supplierHandlingTimesValidation = () =>
  array().when(nameOf<Odc>("Type"), {
    is: OdcType.ODC,
    then: array().of(
      object().shape({
        SupplierGsdb: yupGsdbValidation(""),
        HandlingTime: yupTimesValidation<SupplierHandlingTime>("HandlingTime"),
      })
    ),
    otherwise: undefined,
  });

const sprHandlingTimesValidation = () =>
  array().when(nameOf<Odc>("Type"), {
    is: OdcType.ODC,
    then: array().of(
      object().shape({
        SupplierGsdb: yupGsdbValidation(""),
        PlantGsdb: yupGsdbValidation(""),
        HandlingTime: yupTimesValidation<SprHandlingTime>("HandlingTime"),
      })
    ),
    otherwise: undefined,
  });

export const odcSchema: SchemaOf<Odc> = object()
  .shape({
    Name: string().required(requiredFieldValidationMessage("Name")).default(""),
    Gsdb: yupGsdbValidation(nameOf<Odc>("Gsdb")),
    DefaultInboundHandlingTime: yupTimesValidation<Odc>("DefaultInboundHandlingTime"),
    ReturnHandlingTime: yupTimesValidation<Odc>("ReturnHandlingTime"),
    CountryHandlingTimes: countryHandlingTimesValidation(),
    SupplierHandlingTimes: supplierHandlingTimesValidation(),
    SprHandlingTimes: sprHandlingTimesValidation(),

    // TODO: Remove temporary until final decision is made
    // https://lise.atlassian.net/browse/MDM-207

    // Zipcode: string()
    //   .required(requiredFieldValidationMessage("Zipcode"))
    //   .default(""),
    // ZipArea: string()
    //   .required(requiredFieldValidationMessage("ZipArea"))
    //   .default(""),
    // City: string().required(requiredFieldValidationMessage("City")).default(""),
    CountryId: number().notOneOf([null, 0], "Please choose a Country"),
    Type: number().notOneOf([-1], "Please choose a Location Type"),
  })
  .required();
